import { ESystemMessageType } from 'modules/chat/types';
// @ts-ignore
import { JsonObject } from 'react-use-websocket/dist/lib/types';
import { IUserMinimize } from 'types/user';

export enum EEventType {
  MESSAGE = 'message',
  MESSAGE_UPDATE = 'message_update',
  MESSAGE_DELETE = 'message_destroy',
  LIKE = 'like',
  NOTIFICATION = 'notification',
  THREADS_3D_MODEL = 'threads_3d_model',
  COPILOT_EVENT_SUGGESTIONS = 'copilot_event_suggestions',
  COPILOT_CHAT_MESSAGE = 'copilot_chat_message',
  THREADS_DOC = 'threads_doc',
  THREADS_3D_COMMENT = 'threads_3d_comment',
  THREADS_3D_ANNOTATION = 'threads_3d_annotation',
}

export interface ISocketPayload extends JsonObject {
  type: EEventType;
  context: any;
}
export enum EAction {
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
}

export interface ISystemMessage {
  id: number;
  text: string;
  creator: IUserMinimize;
  type: ESystemMessageType;
  createdAt: string;
  updatedAt: string;
}
